$(document).on(
  "revelation__s27_popup rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);

    const $inputText = $("#inputText");
    const $copyButton = $("#copyButton");
    const $inputCode = $("#codeText");
    const $copyCode = $("#copyCode");
    const copyText = function (input) {
      input.select();
      let successful = false;
      try {
        successful = document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy text: ", err);
      }
    };
    $copyButton.on("click", function () {
      copyText($inputText);
    });
    $copyCode.on("click", function () {
      copyText($inputCode);
    });
  }
);
